module.exports = __webpack_public_path__ + "static/media/yyfwssc.e7224b00.jpg";